webpackJsonp([195196023747953],{

/***/ 851:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---portofolio-laminar-a0e39f21c11f6a62c5ab.js